/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosSession } from '../../models/pos-session';

export interface PosSessionsControllerRemoveHelper$Params {

/**
 * POS Session ID
 */
  id: string;

/**
 * Volunteer User ID to remove
 */
  volunteerId: string;
}

export function posSessionsControllerRemoveHelper(http: HttpClient, rootUrl: string, params: PosSessionsControllerRemoveHelper$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSession>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerRemoveHelper.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('volunteerId', params.volunteerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSession>;
    })
  );
}

posSessionsControllerRemoveHelper.PATH = '/pos/sessions/{id}/helpers/{volunteerId}';
